import React from 'react';
import './Checkbox.css';
/**
 * Renders the Label with Checkbox component.
 *
 * @param {string} id - the ID's of input element
 * @param {React.ReactChild} [children] - the label text
 * @param {string} [className] - the CSS classes prefix -label and -input
 * @param {e => handleChange(e.target.value)} onChange - onChange handler
 * @param {string} value - value for input
 *
 * @example
 * <Checkbox
 *  id='username'
 *  className='a6y-react-auth'
 *  onChange={e => handleChange(e.target.value)}
 *  value={value}
 * >
 *  checkbox text or <p></p>
 * </Checkbox>
 */
var Checkbox = function (_a) {
    var _b, _c;
    var id = _a.id, children = _a.children, _d = _a.className, className = _d === void 0 ? 'a6y-react-auth' : _d, onChange = _a.onChange, value = _a.value;
    var classNames = require('classnames');
    var LabelClass = classNames((_b = {},
        _b[className + "__label--" + id] = id ? true : false,
        _b));
    var InputClass = classNames((_c = {},
        _c[className + "__label__input--" + id] = id ? true : false,
        _c));
    return (React.createElement("label", { htmlFor: id, className: className + "__checkbox-label " + LabelClass },
        React.createElement("p", null, children && children),
        React.createElement("input", { id: id, name: id, type: 'checkbox', onChange: onChange, className: className + "__checkbox-label__input " + InputClass, value: value ? value : '' }),
        React.createElement("span", { className: className + "__checkbox-label__input--checkmark" })));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map